import type { U3141ChildLotChain } from '../U3141Service';

/** Lot supprimable depuis le menu graphe (BL-0125 / BL-0696) : tout nœud sauf le lot principal du registre. */
export function u3141IsGraphDeletableChildLotChain(childLotChain: U3141ChildLotChain, requestedLot: string): boolean {
  const lot = childLotChain.lotDetail?.lot?.trim() ?? '';
  return lot !== requestedLot?.trim();
}
